<template>
  <div class="dash-root">
    <div id="layout-wrapper">

      <!-- ========== TOP BAR ========== -->
      <nav class="dash-topbar">
        <div class="container d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center" style="gap:16px;">
            <a href="javascript:void(0)" @click="$router.push('/')"><img src="/assets/images/flockr_logo.png" alt="Flockr" style="height:34px;" /></a>
            <span class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:15px;">Dashboard</span>
          </div>
          <div class="d-flex align-items-center" style="gap:14px;">
            <!-- Desktop-only inline nav links — collapsed into bottom tab bar on mobile -->
            <div class="dash-top-links d-none d-md-flex align-items-center" style="gap:14px;">
              <a href="javascript:void(0)" @click="$router.push('/forum')" style="color:var(--fm-m,#A09888);font-size:13px;text-decoration:none;"><i class="mdi mdi-account-group me-1"></i>Community</a>
              <a href="javascript:void(0)" @click="$router.push('/marketplace')" style="color:var(--fm-m,#A09888);font-size:13px;text-decoration:none;"><i class="mdi mdi-storefront-outline me-1"></i>Marketplace</a>
              <a href="javascript:void(0)" @click="$router.push('/farm')" style="color:var(--fm-m,#A09888);font-size:13px;text-decoration:none;"><i class="mdi mdi-barn me-1"></i>My Farm</a>
              <a v-if="isAdmin" href="javascript:void(0)" @click="$router.push('/admin')" style="color:#BFA164;font-size:13px;text-decoration:none;" title="Admin Console"><i class="mdi mdi-shield-crown me-1"></i>Admin</a>
            </div>
            <div class="dash-icon-btn d-none d-md-flex" @click="$router.push('/messages')" title="Messages">
              <i class="mdi mdi-message-text-outline" style="font-size:20px;"></i>
            </div>
            <div class="dash-icon-btn" @click="$router.push('/notifications')" :title="bellTooltip" style="position:relative;">
              <i class="mdi mdi-bell-outline" :class="{'dash-bell-active': hasRecentActivity}" style="font-size:20px;"></i>
              <span v-if="unreadCount > 0" class="dash-notif-badge">{{ unreadCount }}</span>
              <span v-else-if="hasRecentActivity" class="dash-notif-pulse" :title="recentActivityCount + ' activities in the last 24h'"></span>
            </div>
            <div class="dash-user-btn" @click="showUserMenu=!showUserMenu">
              <user-avatar :src="user.avatar_url" :name="user.display_name" size="sm" />
            </div>
          </div>
        </div>
      </nav>

      <!-- User Menu Dropdown -->
      <div v-if="showUserMenu" class="dash-user-menu" @click.self="showUserMenu=false">
        <div class="dash-menu-card">
          <div class="d-flex align-items-center gap-3 mb-3 pb-3" style="border-bottom:1px solid var(--fm-br);">
            <user-avatar :src="user.avatar_url" :name="user.display_name" size="lg" />
            <div>
              <div class="fw-semibold" style="color:var(--fm-h,#F5F0E8);">{{ user.display_name }}</div>
              <div style="color:var(--fm-s,#6B6356);font-size:12px;">{{ user.phone }}</div>
            </div>
          </div>
          <a href="javascript:void(0)" class="dash-menu-item" @click="$router.push('/me');showUserMenu=false"><i class="mdi mdi-account-edit me-2"></i>My Profile</a>
          <a href="javascript:void(0)" class="dash-menu-item" @click="$router.push('/my-listings');showUserMenu=false"><i class="mdi mdi-tag-multiple me-2"></i>My Listings</a>
          <a href="javascript:void(0)" class="dash-menu-item" @click="$router.push('/sell/dashboard');showUserMenu=false"><i class="mdi mdi-storefront me-2"></i>My Agro Shop</a>
          <a href="javascript:void(0)" class="dash-menu-item" @click="$router.push('/sell/products');showUserMenu=false"><i class="mdi mdi-package-variant me-2"></i>My Products (Agro-Inputs)</a>
          <a href="javascript:void(0)" class="dash-menu-item" @click="$router.push('/my-offers');showUserMenu=false"><i class="mdi mdi-handshake me-2"></i>My Offers</a>
          <a href="javascript:void(0)" class="dash-menu-item" @click="$router.push('/orders');showUserMenu=false"><i class="mdi mdi-receipt me-2"></i>My Orders</a>
          <a href="javascript:void(0)" class="dash-menu-item" @click="$router.push('/marketplace/saved');showUserMenu=false"><i class="mdi mdi-heart me-2"></i>Saved</a>
          <a href="javascript:void(0)" class="dash-menu-item" @click="$router.push('/my-buy-requests');showUserMenu=false"><i class="mdi mdi-bullhorn me-2"></i>Buy Requests</a>
          <a href="javascript:void(0)" class="dash-menu-item" @click="$router.push('/marketplace/suppliers');showUserMenu=false"><i class="mdi mdi-account-group me-2"></i>Suppliers</a>
          <a href="javascript:void(0)" class="dash-menu-item" style="color:#50C878;" @click="$router.push('/farm');showUserMenu=false"><i class="mdi mdi-barn me-2"></i>My Farm</a>
          <a href="javascript:void(0)" class="dash-menu-item" style="color:#50C878;" @click="$router.push('/verification');showUserMenu=false"><i class="mdi mdi-shield-check me-2"></i>Get Verified</a>
          <a href="javascript:void(0)" class="dash-menu-item" style="color:#BFA164;" @click="$router.push('/developers');showUserMenu=false"><i class="mdi mdi-code-tags me-2"></i>For Developers</a>
          <a v-if="isAdmin" href="javascript:void(0)" class="dash-menu-item" style="color:#BFA164;" @click="$router.push('/admin');showUserMenu=false"><i class="mdi mdi-shield-crown me-2"></i>Admin Console</a>
          <a href="javascript:void(0)" class="dash-menu-item" @click="$router.push('/terms');showUserMenu=false"><i class="mdi mdi-file-document-outline me-2"></i>Terms &amp; Privacy</a>
          <div style="border-top:1px solid var(--fm-br,#1E1E1E);margin-top:8px;padding-top:8px;">
            <a href="javascript:void(0)" class="dash-menu-item" style="color:#FF6B6B;" @click="logout"><i class="mdi mdi-logout me-2"></i>Sign Out</a>
          </div>
        </div>
      </div>

      <!-- ========== CONTENT ========== -->
      <div class="container dash-container">

        <div v-if="loading" class="text-center py-5"><div class="spinner-border text-warning"></div></div>

        <div v-else>
          <!-- Welcome -->
          <div class="dash-welcome mb-4">
            <div>
              <h4 class="fw-bold mb-1" style="color:var(--fm-h,#F5F0E8);">{{ greeting }}, {{ firstName }}!</h4>
              <p style="color:var(--fm-s,#6B6356);font-size:13px;margin:0;">Here's what's happening on your Flockr account.</p>
            </div>
            <button class="btn btn-warning d-none d-md-block" @click="$router.push('/sell/create')">
              <i class="mdi mdi-plus me-1"></i> New Listing
            </button>
          </div>

          <!-- Identity-verification (KYC) soft banner — soft nudge that grows louder
               as the 30-day grace period expires. Days remaining come from the server so
               the grace window can be tuned via `kyc_grace_period_days` without a redeploy. -->
          <div v-if="kycBanner && kycBanner.status !== 'verified'" class="dash-verify-banner mb-4"
               :style="kycBannerStyle">
            <div class="dash-verify-icon">
              <i :class="kycBanner.daysRemaining < 0 ? 'mdi mdi-alert-octagon' : (kycBanner.daysRemaining <= 7 ? 'mdi mdi-clock-alert' : 'mdi mdi-shield-check-outline')"></i>
            </div>
            <div class="dash-verify-body">
              <div class="dash-verify-title">
                <template v-if="kycBanner.daysRemaining < 0">Your listings are due to be unlisted</template>
                <template v-else-if="kycBanner.status === 'pending'">Verification pending — {{ kycBanner.daysRemaining }} day{{ kycBanner.daysRemaining === 1 ? '' : 's' }} left</template>
                <template v-else-if="kycBanner.status === 'rejected'">Please re-submit your ID — {{ kycBanner.daysRemaining }} day{{ kycBanner.daysRemaining === 1 ? '' : 's' }} left</template>
                <template v-else>Verify your identity — {{ kycBanner.daysRemaining }} day{{ kycBanner.daysRemaining === 1 ? '' : 's' }} left</template>
              </div>
              <div class="dash-verify-sub">
                <template v-if="kycBanner.daysRemaining < 0">
                  Your {{ kycBanner.listingsAtRisk }} active listing{{ kycBanner.listingsAtRisk === 1 ? '' : 's' }} will be pulled at the next verification check. Verify now to keep them live.
                </template>
                <template v-else>
                  <template v-if="kycBanner.listingsAtRisk > 0">If your ID isn't verified in time, your {{ kycBanner.listingsAtRisk }} listing{{ kycBanner.listingsAtRisk === 1 ? '' : 's' }} will be removed until you do.</template>
                  <template v-else>Verify your National ID, passport, or driver's licence before the grace window closes.</template>
                </template>
              </div>
            </div>
            <div class="dash-verify-actions">
              <button class="btn btn-warning btn-sm fw-bold" @click="$router.push('/verification')">
                <i class="mdi mdi-shield-check me-1"></i> Verify now
              </button>
            </div>
          </div>

          <!-- Verify-account soft banner — confirm phone OR email is enough to mark the account as verified -->
          <div v-if="showVerifyAccountBanner" class="dash-verify-banner mb-4">
            <div class="dash-verify-icon"><i class="mdi mdi-shield-alert-outline"></i></div>
            <div class="dash-verify-body">
              <div class="dash-verify-title">Verify your account</div>
              <div class="dash-verify-sub">Confirm either your phone or your email to fully activate your account.</div>
            </div>
            <div class="dash-verify-actions">
              <button v-if="!user.phone_verified_at && user.phone && String(user.phone).indexOf('g_') !== 0" class="btn btn-warning btn-sm fw-bold" @click="openVerifyChannel('phone')" :disabled="verifyChannel.sending">
                <i class="mdi mdi-phone-outline me-1"></i> Verify Phone
              </button>
              <button v-if="!user.email_verified_at && user.email" class="btn btn-outline-warning btn-sm fw-bold" @click="openVerifyChannel('email')" :disabled="verifyChannel.sending">
                <i class="mdi mdi-email-outline me-1"></i> Verify Email
              </button>
              <button class="dash-verify-dismiss" @click="dismissVerifyBanner" title="Dismiss">
                <i class="mdi mdi-close"></i>
              </button>
            </div>
          </div>

          <!-- Verify-channel modal — handles both phone and email flows -->
          <div v-if="verifyChannel.open" class="dash-verify-modal" @click.self="closeVerifyChannel">
            <div class="dash-verify-modal-card">
              <div class="dash-verify-modal-head">
                <h5 class="mb-0" style="color:var(--fm-h,#F5F0E8);">Enter Verification Code</h5>
                <button class="dash-verify-dismiss" @click="closeVerifyChannel"><i class="mdi mdi-close"></i></button>
              </div>
              <p style="color:var(--fm-s,#6B6356);font-size:13px;">
                We sent a 6-digit code to <strong>{{ verifyChannel.kind === 'email' ? user.email : user.phone }}</strong>. Enter it below.
              </p>
              <input v-model="verifyChannel.otp" type="text" maxlength="6" class="form-control text-center" placeholder="000000" style="font-size:24px;letter-spacing:8px;font-weight:700;" @keyup.enter="submitVerifyChannel" />
              <div v-if="verifyChannel.error" class="alert alert-danger py-2 px-3 mt-2" style="background:#2D1111;border-color:#5C2020;color:#FF6B6B;font-size:13px;">
                <i class="mdi mdi-alert-circle me-1"></i> {{ verifyChannel.error }}
              </div>
              <button class="btn btn-warning w-100 mt-3" @click="submitVerifyChannel" :disabled="verifyChannel.otp.length < 6 || verifyChannel.verifying">
                <span v-if="!verifyChannel.verifying">Verify</span>
                <span v-else><i class="mdi mdi-loading mdi-spin"></i> Verifying...</span>
              </button>
              <button class="btn btn-outline-secondary w-100 mt-2" @click="resendVerifyChannel" :disabled="verifyChannel.sending">
                <span v-if="!verifyChannel.sending">Resend Code</span>
                <span v-else><i class="mdi mdi-loading mdi-spin"></i></span>
              </button>
            </div>
          </div>

          <!-- Community banner -->
          <div class="dash-community mb-4" @click="$router.push('/forum')">
            <div class="dash-community-icon"><i class="mdi mdi-account-group"></i></div>
            <div class="dash-community-body">
              <div class="dash-community-title">Farmers Community <span class="dash-community-live">LIVE</span></div>
              <div class="dash-community-sub">See what farmers are posting, sharing &amp; asking today — join the conversation</div>
            </div>
            <button class="dash-community-btn">Open feed <i class="mdi mdi-arrow-right"></i></button>
          </div>

          <!-- Stats Row -->
          <div class="row g-3 mb-4">
            <div class="col-6 col-md-3" v-for="stat in statsCards" :key="stat.label">
              <div class="dash-stat-card" @click="stat.route ? $router.push(stat.route) : null" :style="stat.route ? 'cursor:pointer' : ''">
                <i :class="stat.icon" :style="'font-size:22px;color:' + stat.color"></i>
                <div class="dash-stat-val">{{ stat.value }}</div>
                <div class="dash-stat-lbl">{{ stat.label }}</div>
              </div>
            </div>
          </div>

          <!-- Quick Actions -->
          <div class="row g-3 mb-4">
            <div class="col-6 col-md-3" v-for="(qa,qi) in quickActions" :key="'qa-'+qi">
              <div class="dash-quick-card" @click="$router.push(qa.route)">
                <i :class="qa.icon" style="font-size:24px;color:#BFA164;"></i>
                <div class="dash-quick-label">{{ qa.label }}</div>
              </div>
            </div>
          </div>

          <!-- Credit Passport hero tile — Alex 2026-07-23. Every transaction, KYC
               step, farm record and rating builds a portable credit score users can
               share with lenders (MFIs/SACCOs/banks). This tile drives engagement
               back to the platform: transact more → score rises → unlock financing. -->
          <div v-if="creditPassport" class="dash-credit-card mb-4" @click="$router.push('/credit-passport')" :style="{borderColor: creditPassport.tier_colour}">
            <div class="dash-credit-left">
              <div class="dash-credit-label">Flockr Credit Passport</div>
              <div class="dash-credit-score">{{ creditPassport.score }}<span style="font-size:14px;color:var(--fm-s,#6B6356);font-weight:500;">/1000</span></div>
              <div class="dash-credit-tier" :style="{background: creditPassport.tier_colour}">
                <i class="mdi mdi-medal me-1"></i>{{ creditPassport.tier }}
              </div>
              <div v-if="creditPassport.score_delta_30d !== 0" style="font-size:11px;margin-top:4px;">
                <i :class="creditPassport.score_delta_30d > 0 ? 'mdi mdi-trending-up text-success' : 'mdi mdi-trending-down text-danger'"></i>
                <span :class="creditPassport.score_delta_30d > 0 ? 'text-success' : 'text-danger'">
                  {{ creditPassport.score_delta_30d > 0 ? '+' : '' }}{{ creditPassport.score_delta_30d }}
                </span>
                <span style="color:var(--fm-s,#6B6356);"> since last snapshot</span>
              </div>
            </div>
            <div class="dash-credit-right">
              <div class="dash-credit-title">Build credit history that unlocks financing</div>
              <div class="dash-credit-sub">Transact, verify, and log farm records to grow your score. Share it with MFIs, SACCOs and banks.</div>
              <div class="dash-credit-cta">
                <span>Open Passport</span>
                <i class="mdi mdi-arrow-right"></i>
              </div>
            </div>
          </div>

          <!-- Refer & Earn card (Alex 2026-07-17). QR is prominent so farmers can
               show/scan at meetings; the recent-referred list keeps discovery in
               a familiar surface without needing to remember /my-referrals. -->
          <div v-if="referralCode" class="dash-refer-card mb-4">
            <div class="dash-refer-body">
              <div class="dash-refer-headline">
                <i class="mdi mdi-account-multiple-plus-outline" style="color:#BFA164;font-size:22px;"></i>
                <div>
                  <div class="dash-refer-title">Refer &amp; Earn</div>
                  <div class="dash-refer-sub">Share your code so farmers who sign up are credited to you.</div>
                </div>
              </div>
              <div class="dash-refer-code">
                <span class="dash-refer-code-lbl">Your code</span>
                <span class="dash-refer-code-val">{{ referralCode }}</span>
              </div>
              <div class="dash-refer-actions">
                <button class="btn btn-sm btn-warning" @click="copyText(referralCode)"><i class="mdi mdi-content-copy me-1"></i>Copy code</button>
                <a v-if="referralWhatsappLink" :href="referralWhatsappLink" target="_blank" class="btn btn-sm btn-success"><i class="mdi mdi-whatsapp me-1"></i>WhatsApp</a>
                <button v-if="referralSmsBody" class="btn btn-sm btn-outline-info" @click="referralSmsOpen = true"><i class="mdi mdi-message-text me-1"></i>SMS to friend</button>
                <button class="btn btn-sm btn-outline-secondary" @click="downloadReferralQR"><i class="mdi mdi-download me-1"></i>Save QR</button>
                <button class="btn btn-sm btn-outline-warning" @click="$router.push('/my-referrals')">View all <i class="mdi mdi-arrow-right ms-1"></i></button>
              </div>

              <!-- Recent referred people (top 3) -->
              <div v-if="referralPeople.length" class="dash-refer-list">
                <div class="dash-refer-list-lbl">Recently brought in ({{ referralPeople.length }})</div>
                <div v-for="p in referralPeople.slice(0,3)" :key="p.id" class="dash-refer-row" @click="$router.push('/my-referrals')">
                  <div class="dash-refer-avatar">{{ referralInitials(p.display_name) }}</div>
                  <div class="flex-fill">
                    <div style="font-weight:600;font-size:13px;">{{ p.display_name }}</div>
                    <div style="font-size:11px;color:var(--fm-s,#6B6356);">{{ p.phone }} · {{ formatDateShort(p.created_at) }}</div>
                  </div>
                  <span v-if="Number(p.listing_count) || Number(p.order_count)" class="badge bg-success bg-opacity-15 text-success" style="font-size:10px;">Active</span>
                  <span v-else class="badge bg-secondary bg-opacity-15 text-muted" style="font-size:10px;">Joined</span>
                </div>
              </div>
            </div>

            <!-- QR block on the right — tap to enlarge -->
            <div class="dash-refer-qr">
              <img :src="referralQrUrl" alt="Scan to sign up" class="dash-refer-qr-img" @click="referralQrOpen = true" />
              <div class="dash-refer-qr-hint">Tap to enlarge · scan to sign up</div>
            </div>
          </div>

          <!-- SMS-to-a-friend modal — asks for the recipient's phone, then opens
               the device SMS app with recipient AND body prefilled. Falls back to
               server-send via existing SMS provider if the device can't handle sms:. -->
          <div v-if="referralSmsOpen" class="dash-modal-backdrop" @click.self="referralSmsOpen = false">
            <div class="dash-refer-qr-modal" style="text-align:left;">
              <button class="dash-modal-close" @click="referralSmsOpen = false"><i class="mdi mdi-close"></i></button>
              <div style="font-size:14px;font-weight:700;color:#1A1A1A;margin-bottom:4px;">
                <i class="mdi mdi-message-text me-1" style="color:#4FC3F7;"></i>Send referral link via SMS
              </div>
              <div style="font-size:12px;color:#6B6356;margin-bottom:12px;">
                We'll pre-fill your phone's SMS app with their number and your referral link. Just tap Send.
              </div>
              <label style="font-size:11px;color:#6B6356;font-weight:600;text-transform:uppercase;letter-spacing:.5px;">Friend's phone</label>
              <div style="display:flex;gap:8px;margin-top:4px;">
                <div style="position:relative;flex:1;">
                  <span style="position:absolute;left:12px;top:50%;transform:translateY(-50%);color:#8A827A;font-size:13px;">+254</span>
                  <input v-model="referralSmsPhone" type="tel" maxlength="10" placeholder="7XX XXX XXX" style="width:100%;padding:10px 12px 10px 52px;border:1px solid #E0D8D0;border-radius:8px;font-size:14px;color:#1A1A1A;background:#FFFFFF;" @keyup.enter="sendReferralSms" />
                </div>
                <button class="btn btn-warning fw-bold" @click="sendReferralSms" :disabled="referralSmsSending || !referralSmsPhone">
                  <span v-if="referralSmsSending"><span class="spinner-border spinner-border-sm me-1"></span>…</span>
                  <span v-else><i class="mdi mdi-send me-1"></i>Send</span>
                </button>
              </div>
              <div v-if="referralSmsMsg" :style="{color: referralSmsOk ? '#50C878' : '#FF6B6B'}" style="font-size:12px;margin-top:10px;">
                <i :class="referralSmsOk ? 'mdi mdi-check-circle me-1' : 'mdi mdi-alert me-1'"></i>{{ referralSmsMsg }}
              </div>
              <div style="font-size:11px;color:#8A827A;margin-top:14px;background:#F7F5F2;border-radius:8px;padding:8px 10px;line-height:1.4;">
                <strong>Preview:</strong><br>{{ referralSmsBody }}
              </div>
            </div>
          </div>

          <!-- Enlarged QR modal (dashboard variant) -->
          <div v-if="referralQrOpen" class="dash-modal-backdrop" @click.self="referralQrOpen = false">
            <div class="dash-refer-qr-modal">
              <button class="dash-modal-close" @click="referralQrOpen = false"><i class="mdi mdi-close"></i></button>
              <div style="font-size:11px;color:#6B6356;text-transform:uppercase;letter-spacing:1px;font-weight:600;">Scan to sign up with</div>
              <div style="font-size:32px;letter-spacing:6px;font-weight:800;color:#BFA164;font-family:'Courier New',monospace;margin:4px 0 14px;">{{ referralCode }}</div>
              <img :src="referralQrUrlLarge" alt="Referral QR" style="width:100%;max-width:360px;height:auto;border-radius:10px;background:#FFFFFF;padding:12px;border:1px solid #E8E2DA;" />
              <div style="font-size:13px;color:#6B6356;margin-top:10px;">Point a phone camera at this code.</div>
              <div v-if="referralShareUrl" style="font-size:11px;color:#8A827A;margin-top:6px;word-break:break-all;">{{ referralShareUrl }}</div>
            </div>
          </div>

          <!-- Developers banner — shown only until dismissed; promotes the API portal to first-time visitors -->
          <div v-if="showDevelopersBanner" class="dash-devs-banner mb-4">
            <div class="dash-devs-icon"><i class="mdi mdi-code-tags"></i></div>
            <div class="dash-devs-body" @click="openDevelopersPortal">
              <div class="dash-devs-title">
                Build on Flockr
                <span class="dash-devs-tag">NEW</span>
              </div>
              <div class="dash-devs-sub">Register an app, get an API key, and integrate listings, sales &amp; webhooks in minutes.</div>
            </div>
            <button class="dash-devs-cta" @click="openDevelopersPortal">
              Explore <i class="mdi mdi-arrow-right ms-1"></i>
            </button>
            <button class="dash-devs-dismiss" @click="dismissDevelopersBanner" title="Dismiss">
              <i class="mdi mdi-close"></i>
            </button>
          </div>

          <!-- Vet Services Banner -->
          <div class="dash-card mb-4 d-flex align-items-center justify-content-between" style="cursor:pointer;" @click="$router.push('/vet/dashboard')">
            <div class="d-flex align-items-center gap-3">
              <div style="width:42px;height:42px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:20px;" :style="{background:isVet?'rgba(80,200,120,.1)':'rgba(191,161,100,.08)',color:isVet?'#50C878':'#BFA164'}">🩺</div>
              <div>
                <div style="color:var(--fm-h,#F5F0E8);font-weight:600;font-size:14px;">{{ isVet ? 'Vet Dashboard' : 'Offer Vet Services' }}</div>
                <div style="color:var(--fm-s,#6B6356);font-size:11px;">{{ isVet ? 'Manage appointments, earnings & profile' : 'Register as a vet to receive bookings from farmers' }}</div>
              </div>
            </div>
            <i class="mdi mdi-chevron-right" style="color:var(--fm-s,#6B6356);font-size:20px;"></i>
          </div>

          <!-- Transport Banner — always visible, routes based on role -->
          <div class="dash-card mb-4 d-flex align-items-center justify-content-between" style="cursor:pointer;" @click="$router.push('/my-transports')">
            <div class="d-flex align-items-center gap-3">
              <div style="width:42px;height:42px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:20px;background:rgba(241,180,76,.12);color:#f1b44c;">🚛</div>
              <div>
                <div style="color:var(--fm-h,#F5F0E8);font-weight:600;font-size:14px;">My Transport Bookings</div>
                <div style="color:var(--fm-s,#6B6356);font-size:11px;">Track requested transports, follow live trip status, view past deliveries</div>
              </div>
            </div>
            <i class="mdi mdi-chevron-right" style="color:var(--fm-s,#6B6356);font-size:20px;"></i>
          </div>

          <!-- Cart Banner — shows badge when items present -->
          <div class="dash-card mb-4 d-flex align-items-center justify-content-between" style="cursor:pointer;" @click="$router.push('/cart')">
            <div class="d-flex align-items-center gap-3">
              <div style="width:42px;height:42px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:20px;background:rgba(191,161,100,.12);color:#BFA164;position:relative;">
                <i class="mdi mdi-cart"></i>
                <span v-if="cartCount" style="position:absolute;top:-4px;right:-4px;background:#FF6B6B;color:#fff;border-radius:10px;padding:1px 6px;font-size:10px;font-weight:700;min-width:18px;text-align:center;">{{ cartCount }}</span>
              </div>
              <div>
                <div style="color:var(--fm-h,#F5F0E8);font-weight:600;font-size:14px;">My Cart</div>
                <div style="color:var(--fm-s,#6B6356);font-size:11px;">{{ cartCount ? cartCount + ' item' + (cartCount===1?'':'s') + ' ready to checkout' : 'Add animals or products from the marketplace' }}</div>
              </div>
            </div>
            <i class="mdi mdi-chevron-right" style="color:var(--fm-s,#6B6356);font-size:20px;"></i>
          </div>

          <!-- Agro-Input Shop Banner -->
          <div class="dash-card mb-4 d-flex align-items-center justify-content-between" style="cursor:pointer;" @click="$router.push('/shop')">
            <div class="d-flex align-items-center gap-3">
              <div style="width:42px;height:42px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:20px;background:rgba(241,196,15,.12);color:#f1c40f;">📦</div>
              <div>
                <div style="color:var(--fm-h,#F5F0E8);font-weight:600;font-size:14px;">Agro-Input Shop</div>
                <div style="color:var(--fm-s,#6B6356);font-size:11px;">Feeds, supplements, vet drugs, equipment — delivered or pick up</div>
              </div>
            </div>
            <i class="mdi mdi-chevron-right" style="color:var(--fm-s,#6B6356);font-size:20px;"></i>
          </div>

          <!-- Community & Learning Banner — funnels to /forum (which has its own Learning Hub link) -->
          <div class="dash-card mb-4 d-flex align-items-center justify-content-between" style="cursor:pointer;" @click="$router.push('/forum')">
            <div class="d-flex align-items-center gap-3">
              <div style="width:42px;height:42px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:20px;background:rgba(155,89,182,.12);color:#9b59b6;">📚</div>
              <div>
                <div style="color:var(--fm-h,#F5F0E8);font-weight:600;font-size:14px;">Community &amp; Learning</div>
                <div style="color:var(--fm-s,#6B6356);font-size:11px;">Read farmer guides, ask the forum, get vet-verified answers</div>
              </div>
            </div>
            <i class="mdi mdi-chevron-right" style="color:var(--fm-s,#6B6356);font-size:20px;"></i>
          </div>

          <!-- Market Intelligence Banner -->
          <div class="dash-card mb-4 d-flex align-items-center justify-content-between" style="cursor:pointer;" @click="$router.push('/market')">
            <div class="d-flex align-items-center gap-3">
              <div style="width:42px;height:42px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:20px;background:rgba(79,195,247,.12);color:#4FC3F7;">📈</div>
              <div>
                <div style="color:var(--fm-h,#F5F0E8);font-weight:600;font-size:14px;">Market Intelligence</div>
                <div style="color:var(--fm-s,#6B6356);font-size:11px;">Weekly livestock prices per county + market reports — know what your animals are worth</div>
              </div>
            </div>
            <i class="mdi mdi-chevron-right" style="color:var(--fm-s,#6B6356);font-size:20px;"></i>
          </div>

          <!-- Insurance Banner — protect the herd -->
          <div class="dash-card mb-4 d-flex align-items-center justify-content-between" style="cursor:pointer;" @click="$router.push('/insurance')">
            <div class="d-flex align-items-center gap-3">
              <div style="width:42px;height:42px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:20px;background:rgba(80,200,120,.12);color:#50C878;">🛡️</div>
              <div>
                <div style="color:var(--fm-h,#F5F0E8);font-weight:600;font-size:14px;">Insurance &amp; Finance</div>
                <div style="color:var(--fm-s,#6B6356);font-size:11px;">Cover your animals plus access farmer-friendly loans and asset financing — KLIP, APA, UAP, Jubilee + partner lenders</div>
              </div>
            </div>
            <i class="mdi mdi-chevron-right" style="color:var(--fm-s,#6B6356);font-size:20px;"></i>
          </div>

          <!-- Corporate Accounts banner — both sides: corporates you supply + sellers who supply you on credit -->
          <div class="dash-card mb-4 d-flex align-items-center justify-content-between" style="cursor:pointer;" @click="$router.push('/my-corporate-clients')">
            <div class="d-flex align-items-center gap-3">
              <div style="width:42px;height:42px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:20px;background:rgba(191,161,100,.14);color:#BFA164;"><i class="mdi mdi-domain"></i></div>
              <div>
                <div style="color:var(--fm-h,#F5F0E8);font-weight:600;font-size:14px;">Corporate Accounts</div>
                <div style="color:var(--fm-s,#6B6356);font-size:11px;">Two-sided view — the corporates you supply (My Clients) and the sellers who supply you on credit terms (On My Account With).</div>
              </div>
            </div>
            <i class="mdi mdi-chevron-right" style="color:var(--fm-s,#6B6356);font-size:20px;"></i>
          </div>

          <!-- WORKER TASKS — shows for anyone with assigned tasks -->
          <div v-if="workerFarms.length||workerTasks.length" class="dash-card mb-4">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <h6 class="fw-bold mb-0" style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-clipboard-list me-2" style="color:#BFA164;"></i>My Tasks</h6>
              <div class="d-flex gap-2 align-items-center">
                <span v-if="workerStats.overdueTasks" style="background:#c62828;color:#fff;font-size:10px;padding:2px 8px;border-radius:10px;font-weight:600;">{{ workerStats.overdueTasks }} overdue</span>
                <span style="color:var(--fm-s,#6B6356);font-size:12px;">{{ workerStats.pendingTasks }} pending</span>
              </div>
            </div>

            <!-- Farm chips -->
            <div v-if="workerFarms.length" class="d-flex gap-2 flex-wrap mb-3">
              <div v-for="wf in workerFarms" :key="wf.farm_id" class="d-flex align-items-center gap-2" style="background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:8px;padding:6px 10px;cursor:pointer;" @click="$router.push('/farm')">
                <i class="mdi mdi-barn" style="color:#BFA164;"></i>
                <div><div style="color:var(--fm-h,#F5F0E8);font-size:12px;font-weight:600;">{{ wf.farm_name }}</div><div style="color:var(--fm-s,#6B6356);font-size:10px;text-transform:capitalize;">{{ wf.role }}</div></div>
              </div>
            </div>

            <!-- Task list -->
            <div v-for="wt in workerTasks" :key="'wt-'+wt.id" style="background:var(--fm-bg2,#0F0F0F);border:1px solid #1A1A1A;border-radius:10px;padding:12px;margin-bottom:8px;">
              <div class="d-flex justify-content-between align-items-start">
                <div class="flex-fill">
                  <div class="d-flex align-items-center gap-2 flex-wrap">
                    <strong style="color:var(--fm-h,#F5F0E8);font-size:13px;">{{ wt.title }}</strong>
                    <span class="dash-status-dot" :class="'st-'+wt.status">{{ (wt.status||'').replace(/_/g,' ') }}</span>
                    <span :style="{color:wt.priority==='high'?'#FF6B6B':wt.priority==='medium'?'#FF9800':'#6B6356',fontSize:'10px',fontWeight:600}">{{ wt.priority }}</span>
                  </div>
                  <div v-if="wt.description" style="color:var(--fm-s,#6B6356);font-size:12px;margin-top:3px;">{{ wt.description }}</div>
                  <div style="color:var(--fm-m,#A09888);font-size:11px;margin-top:4px;">
                    <i class="mdi mdi-barn me-1"></i>{{ wt.farm_name }}
                    <span class="ms-2"><i class="mdi mdi-calendar me-1"></i>{{ fDate(wt.due_date) }}</span>
                    <span v-if="wt.due_time" class="ms-1">{{ formatTime(wt.due_time) }}</span>
                    <span v-if="wt.animal_name" class="ms-2"><i class="mdi mdi-cow me-1"></i>{{ wt.animal_name }}</span>
                  </div>
                  <div v-if="wt.require_photo==='1'||wt.require_gps==='1'||wt.require_notes==='1'" style="margin-top:4px;display:flex;gap:4px;flex-wrap:wrap;">
                    <span v-if="wt.require_photo==='1'" class="dash-req-chip" style="color:#0288D1;background:rgba(79,195,247,.15);">📷 Photo</span>
                    <span v-if="wt.require_gps==='1'" class="dash-req-chip" style="color:#E53935;background:rgba(255,107,107,.15);">📍 GPS</span>
                    <span v-if="wt.require_notes==='1'" class="dash-req-chip" style="color:#8a6d3b;background:rgba(191,161,100,.15);">📝 Notes</span>
                  </div>
                </div>
                <div class="d-flex gap-1 flex-shrink-0 ms-2">
                  <button v-if="wt.status==='pending'" class="btn btn-sm btn-outline-info" @click="workerStartTask(wt)" title="Start"><i class="mdi mdi-play"></i></button>
                  <button v-if="wt.status==='in_progress'&&workerTaskNeedsEvidence(wt)" class="btn btn-sm btn-outline-success" @click="workerCompleteWithEvidence(wt)" title="Complete with evidence"><i class="mdi mdi-camera-plus"></i></button>
                  <button v-if="wt.status==='in_progress'&&!workerTaskNeedsEvidence(wt)" class="btn btn-sm btn-outline-success" @click="workerCompleteTask(wt)" title="Complete"><i class="mdi mdi-check"></i></button>
                </div>
              </div>
            </div>

            <div v-if="workerTasks.length===0" style="color:var(--fm-s,#6B6356);font-size:12px;text-align:center;padding:16px;">
              <i class="mdi mdi-check-circle" style="font-size:24px;color:#50C878;display:block;margin-bottom:4px;"></i>
              All tasks completed! Great work.
            </div>

            <div v-if="workerCompleted.length" style="margin-top:12px;">
              <div style="color:var(--fm-s,#6B6356);font-size:11px;font-weight:600;margin-bottom:6px;">Recently Completed ({{ workerCompleted.length }})</div>
              <div v-for="wc in workerCompleted.slice(0,5)" :key="'wc-'+wc.id" class="d-flex align-items-center gap-2 py-1" style="border-bottom:1px solid var(--fm-br);">
                <i class="mdi mdi-check-circle" style="color:#50C878;font-size:14px;"></i>
                <span style="color:var(--fm-m,#A09888);font-size:12px;flex:1;">{{ wc.title }}</span>
                <span style="color:var(--fm-s,#6B6356);font-size:10px;">{{ wc.farm_name }}</span>
              </div>
            </div>
          </div>

          <div class="row g-4">
            <!-- Recent Listings -->
            <div class="col-lg-6">
              <div class="dash-card">
                <div class="d-flex align-items-center justify-content-between mb-3">
                  <h6 class="fw-bold mb-0" style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-tag-multiple me-2"></i>My Listings</h6>
                  <a href="javascript:void(0)" @click="$router.push('/my-listings')" style="color:#BFA164;font-size:12px;text-decoration:none;">View All</a>
                </div>
                <div v-if="recentListings.length === 0" class="text-center py-3">
                  <p style="color:var(--fm-s,#6B6356);font-size:13px;">No listings yet</p>
                  <button class="btn btn-sm btn-warning" @click="$router.push('/sell/create')"><i class="mdi mdi-plus me-1"></i>Create</button>
                </div>
                <div v-else>
                  <div v-for="(l,li) in recentListings.slice(0,5)" :key="'l-'+li" class="dash-list-item" @click="$router.push('/marketplace/listing/'+l.id)">
                    <div class="dash-list-thumb">
                      <img v-if="l.primary_photo" :src="photoUrl(l.primary_photo)" />
                      <i v-else class="mdi mdi-paw" style="font-size:16px;color:#BFA164;"></i>
                    </div>
                    <div class="flex-fill">
                      <div class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:13px;">{{ l.title }}</div>
                      <div style="color:#BFA164;font-size:12px;font-weight:600;">KES {{ formatPrice(l.price) }}</div>
                    </div>
                    <span class="dash-status-dot" :class="'st-'+l.status">{{ l.status }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Recent Offers -->
            <div class="col-lg-6">
              <div class="dash-card">
                <div class="d-flex align-items-center justify-content-between mb-3">
                  <h6 class="fw-bold mb-0" style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-handshake me-2"></i>Recent Offers</h6>
                  <a href="javascript:void(0)" @click="$router.push('/my-offers')" style="color:#BFA164;font-size:12px;text-decoration:none;">View All</a>
                </div>
                <div v-if="recentOffers.length === 0" class="text-center py-3"><p style="color:var(--fm-s,#6B6356);font-size:13px;">No offers received yet</p></div>
                <div v-else>
                  <div v-for="(o,oi) in recentOffers.slice(0,5)" :key="'o-'+oi" class="dash-list-item">
                    <div class="dash-avatar-xs">{{ getInitials(o.buyer_name) }}</div>
                    <div class="flex-fill">
                      <div class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:13px;">{{ o.buyer_name }}</div>
                      <div style="color:#BFA164;font-size:12px;font-weight:600;">KES {{ formatPrice(o.offered_price) }}</div>
                      <div style="color:var(--fm-s,#6B6356);font-size:11px;">{{ o.listing_title }}</div>
                    </div>
                    <span class="dash-status-dot" :class="'st-'+o.status">{{ o.status }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Wallet -->
          <div class="dash-card mt-4" v-if="wallet.id" style="cursor:pointer;" @click="$router.push('/wallet')">
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <h6 class="fw-bold mb-1" style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-wallet me-2"></i>Wallet Balance</h6>
                <div style="font-size:28px;font-weight:700;color:#BFA164;">KES {{ formatPrice(wallet.available_balance) }}</div>
                <div v-if="wallet.escrow_balance > 0" style="color:var(--fm-s,#6B6356);font-size:12px;">In escrow: KES {{ formatPrice(wallet.escrow_balance) }}</div>
              </div>
              <i class="mdi mdi-chevron-right" style="font-size:24px;color:var(--fm-s,#6B6356);"></i>
            </div>
          </div>

          <!-- Notifications -->
          <div class="dash-card mt-4" v-if="notifications.length > 0">
            <h6 class="fw-bold mb-3" style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-bell me-2"></i>Recent Notifications</h6>
            <div v-for="(n,ni) in notifications.slice(0,5)" :key="'n-'+ni" class="dash-notif-item" :class="{unread:!n.is_read}">
              <div class="dash-notif-dot" v-if="!n.is_read"></div>
              <div class="flex-fill">
                <div style="color:var(--fm-h,#F5F0E8);font-size:13px;">{{ n.title }}</div>
                <div style="color:var(--fm-s,#6B6356);font-size:11px;">{{ n.message }}</div>
              </div>
              <div style="color:var(--fm-s,#6B6356);font-size:10px;white-space:nowrap;">{{ formatTimeAgo(n.created_at) }}</div>
            </div>
          </div>

          <!-- Mobile New Listing -->
          <div class="d-md-none text-center mt-4">
            <button class="btn btn-warning w-100" @click="$router.push('/sell/create')"><i class="mdi mdi-plus me-1"></i> New Listing</button>
          </div>
        </div>
      </div>

      <!-- WORKER EVIDENCE MODAL -->
      <div v-if="showWorkerEvidence" class="dash-overlay" @click.self="showWorkerEvidence=false"><div class="dash-evidence-modal">
        <h6 style="color:var(--fm-h,#F5F0E8);font-size:15px;"><i class="mdi mdi-check-decagram me-2" style="color:#50C878;"></i>Complete Task</h6>
        <div style="background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:8px;padding:10px;margin-bottom:12px;">
          <strong style="color:var(--fm-h,#F5F0E8);font-size:13px;">{{ workerEvidenceTask.title }}</strong>
          <div style="color:var(--fm-s,#6B6356);font-size:11px;">{{ workerEvidenceTask.farm_name }} · Due: {{ fDate(workerEvidenceTask.due_date) }}</div>
        </div>
        <div v-if="workerEvidenceTask.require_photo==='1'" class="mb-3">
          <label style="font-size:11px;font-weight:600;color:var(--fm-m,#A09888);display:block;margin-bottom:4px;"><i class="mdi mdi-camera me-1" style="color:#4FC3F7;"></i>Photo Evidence *</label>
          <div class="d-flex gap-2 mb-2">
            <button class="btn btn-sm btn-outline-info" @click="$refs.wEvidenceFile.click()"><i class="mdi mdi-image-plus me-1"></i>Gallery</button>
            <button class="btn btn-sm btn-outline-info" @click="openWorkerCamera()"><i class="mdi mdi-camera me-1"></i>Take Photo</button>
          </div>
          <input type="file" ref="wEvidenceFile" accept="image/*" multiple @change="handleWorkerEvidenceFiles" style="display:none;" />
          <div v-if="wEvidencePhotos.length" class="d-flex gap-2 flex-wrap">
            <div v-for="(p,pi) in wEvidencePhotos" :key="pi" style="position:relative;width:65px;height:65px;border-radius:8px;overflow:hidden;border:1px solid var(--fm-br,#2A2520);">
              <img :src="p.preview" style="width:100%;height:100%;object-fit:cover;" />
              <button class="btn btn-sm" style="position:absolute;top:1px;right:1px;background:rgba(0,0,0,.6);color:#FF6B6B;padding:0 3px;font-size:11px;border-radius:3px;" @click="wEvidencePhotos.splice(pi,1)"><i class="mdi mdi-close"></i></button>
              <div style="position:absolute;bottom:0;left:0;right:0;background:rgba(0,0,0,.7);color:var(--fm-s,#6B6356);font-size:8px;text-align:center;padding:1px;">{{ (p.size/1024).toFixed(0) }}KB</div>
            </div>
          </div>
        </div>
        <div v-if="workerEvidenceTask.require_gps==='1'" class="mb-3">
          <label style="font-size:11px;font-weight:600;color:var(--fm-m,#A09888);display:block;margin-bottom:4px;"><i class="mdi mdi-map-marker me-1" style="color:#FF6B6B;"></i>GPS Location *</label>
          <div v-if="wEvidenceGps.lat" style="background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#2A2520);border-radius:8px;padding:8px;display:flex;align-items:center;gap:8px;">
            <i class="mdi mdi-check-circle" style="color:#50C878;font-size:18px;"></i>
            <div><div style="color:var(--fm-h,#F5F0E8);font-size:11px;">{{ wEvidenceGps.lat.toFixed(6) }}, {{ wEvidenceGps.lng.toFixed(6) }}</div><div style="color:var(--fm-s,#6B6356);font-size:10px;">Accuracy: {{ wEvidenceGps.accuracy?wEvidenceGps.accuracy.toFixed(0)+'m':'—' }}</div></div>
            <button class="btn btn-sm btn-outline-warning ms-auto" @click="captureWorkerGps"><i class="mdi mdi-refresh"></i></button>
          </div>
          <button v-else class="btn btn-sm btn-outline-warning" @click="captureWorkerGps" :disabled="wCapturingGps">
            <span v-if="wCapturingGps"><span class="spinner-border spinner-border-sm me-1"></span>Getting location...</span>
            <span v-else><i class="mdi mdi-crosshairs-gps me-1"></i>Capture My Location</span>
          </button>
          <div v-if="wGpsError" style="color:#FF6B6B;font-size:11px;margin-top:3px;">{{ wGpsError }}</div>
        </div>
        <div v-if="workerEvidenceTask.require_notes==='1'" class="mb-3">
          <label style="font-size:11px;font-weight:600;color:var(--fm-m,#A09888);display:block;margin-bottom:4px;"><i class="mdi mdi-text me-1" style="color:#BFA164;"></i>Notes *</label>
          <textarea v-model="wEvidenceNotes" class="form-control form-control-sm" rows="3" style="background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#2A2520);color:var(--fm-h,#F5F0E8);" placeholder="What was done, observations..."></textarea>
        </div>
        <div v-if="workerEvidenceTask.require_notes!=='1'" class="mb-3">
          <label style="font-size:11px;font-weight:600;color:var(--fm-m,#A09888);display:block;margin-bottom:4px;">Notes (optional)</label>
          <input v-model="wEvidenceNotes" class="form-control form-control-sm" style="background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#2A2520);color:var(--fm-h,#F5F0E8);" placeholder="Any notes..." />
        </div>
        <button class="btn btn-success w-100" @click="submitWorkerEvidence" :disabled="!canSubmitWorkerEvidence||processing">
          <span v-if="processing"><span class="spinner-border spinner-border-sm me-1"></span>Submitting...</span>
          <span v-else><i class="mdi mdi-check-decagram me-1"></i>Complete with Evidence</span>
        </button>
        <button class="btn btn-sm btn-link text-muted w-100 mt-1" @click="showWorkerEvidence=false">Cancel</button>
      </div></div>

    </div>

    <!-- ========== MOBILE BOTTOM TAB BAR — feels like a native app on phones ========== -->
    <nav class="dash-tabbar d-md-none">
      <a href="javascript:void(0)" class="dash-tab" :class="{active:$route.path==='/dashboard'||$route.path==='/'}" @click="$router.push('/dashboard')">
        <i class="mdi mdi-view-dashboard"></i><span>Home</span>
      </a>
      <a href="javascript:void(0)" class="dash-tab" :class="{active:$route.path.indexOf('/marketplace')===0}" @click="$router.push('/marketplace')">
        <i class="mdi mdi-storefront-outline"></i><span>Market</span>
      </a>
      <a href="javascript:void(0)" class="dash-tab" :class="{active:$route.path.indexOf('/farm')===0}" @click="$router.push('/farm')">
        <i class="mdi mdi-barn"></i><span>Farm</span>
      </a>
      <a href="javascript:void(0)" class="dash-tab" :class="{active:$route.path.indexOf('/forum')===0}" @click="$router.push('/forum')">
        <i class="mdi mdi-forum-outline"></i><span>Chat</span>
      </a>
      <a href="javascript:void(0)" class="dash-tab" :class="{active:showUserMenu}" @click="showUserMenu=!showUserMenu">
        <i class="mdi mdi-menu"></i><span>Menu</span>
      </a>
    </nav>

    <!-- Terms gate — auto-pops if user hasn't accepted current version -->
    <terms-gate />
  </div>
</template>
<style>

/* === GLOBAL THEME === */
html[data-theme="light"] body { background:#FFFFFF!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-card,html[data-theme="light"] .p2c,html[data-theme="light"] .ld-section,html[data-theme="light"] .ld-action-card,html[data-theme="light"] .ld-seller-card,html[data-theme="light"] .ld-info-card,html[data-theme="light"] .ld-related-card { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-overlay .fm-modal,html[data-theme="light"] .ad-overlay .ad-modal { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-input,html[data-theme="light"] .fm-select { background:#F7F5F2!important; border-color:#E0D8D0!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-label { color:#555!important; }
html[data-theme="dark"] body { background:#0A0A0A!important; color:#F5F0E8!important; }
</style>
<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] body{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .card{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .card-body{color:#1A1A1A!important}
html[data-theme="light"] .modal-content{background:#FFFFFF!important;border-color:#E8E2DA!important;color:#1A1A1A!important}
html[data-theme="light"] .form-control,html[data-theme="light"] .form-select{background:#FFFFFF!important;border-color:#E0D8D0!important;color:#1A1A1A!important}
html[data-theme="light"] .table{color:#1A1A1A!important}
html[data-theme="light"] .table th{color:#555!important;border-color:#E8E2DA!important}
html[data-theme="light"] .table td{border-color:#F0EBE4!important}
html[data-theme="light"] [style*="color:#F5F0E8"]{color:#1A1A1A!important}
html[data-theme="light"] [style*="color:#6B6356"]{color:#777!important}
html[data-theme="light"] [style*="color:#A09888"]{color:#555!important}
html[data-theme="light"] [style*="background:#0F0F0F"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#141414"]{background:#FFFFFF!important}
html[data-theme="light"] [style*="background:#1E1E1E"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="background:#0A0A0A"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#1a1510"]{background:#FFF8F0!important}
html[data-theme="light"] [style*="background:#1A1A1A"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="background:#0F200F"]{background:#EDF7EF!important}
html[data-theme="light"] [style*="background:#200F0F"]{background:#FFF2F2!important}
html[data-theme="light"] [style*="background:#0F2030"]{background:#E8F4FD!important}
html[data-theme="light"] [style*="background:#2A2520"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="border:1px solid #1E1E1E"]{border-color:#E8E2DA!important}
html[data-theme="light"] [style*="border:1px solid #2A2520"]{border-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1A1A1A"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1E1E1E"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #2A2520"]{border-bottom-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-top:1px solid #2A2520"]{border-top-color:#E0D8D0!important}
html[data-theme="light"] [style*="color:#BFA164"]{color:#BFA164!important}
html[data-theme="light"] [style*="color:#50C878"]{color:#50C878!important}
html[data-theme="light"] [style*="color:#4FC3F7"]{color:#4FC3F7!important}
html[data-theme="light"] [style*="color:#FF6B6B"]{color:#FF6B6B!important}
html[data-theme="light"] [style*="color:#FF9800"]{color:#FF9800!important}
html[data-theme="light"] [style*="color:#CE93D8"]{color:#CE93D8!important}

html[data-theme="light"] .dash-root,html[data-theme="light"] .dash-root #layout-wrapper{background:#F7F5F2!important;color:#1A1A1A!important;}
html[data-theme="light"] .dash-topbar{background:rgba(247,245,242,.96)!important;border-bottom-color:#E8E2DA!important;}
html[data-theme="light"] .dash-user-menu{background:rgba(0,0,0,.08)!important;}
</style>
<style scoped>
.dash-root,.dash-root #layout-wrapper{background:var(--fm-bg2,#0F0F0F)!important;min-height:100vh;color:var(--fm-h,#F5F0E8)!important}
.dash-topbar{position:sticky;top:0;z-index:100;padding:12px 0;background:var(--fm-bg2,#0F0F0F)!important;backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}
html[data-theme="light"] .dash-root,html[data-theme="light"] .dash-root #layout-wrapper{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .dash-topbar{background:rgba(247,245,242,.96)!important}
html[data-theme="light"] .dash-evidence-modal{background:#FFFFFF!important;border-color:#E8E2DA!important;color:#1A1A1A!important}
html[data-theme="light"] .dash-stat-card,html[data-theme="light"] .dash-quick-card,html[data-theme="light"] .dash-card{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .dash-community{background:linear-gradient(120deg,#f4ead0,#fbf7ee)!important;border-color:#BFA164!important}
html[data-theme="light"] .dash-community-title{color:#1A1A1A!important}
html[data-theme="light"] .dash-community-sub{color:#7a6a45!important}
html[data-theme="light"] .dash-community-icon{background:rgba(191,161,100,.18)!important;color:#9a7c3a!important}
html[data-theme="light"] .dash-stat-card:hover{border-color:#D9D0C5!important}
html[data-theme="light"] .dash-quick-card:hover{border-color:#BFA164!important}
html[data-theme="light"] .dash-menu-card{background:#FFFFFF!important;border-color:#E8E2DA!important;box-shadow:0 8px 24px rgba(0,0,0,.1)!important}
html[data-theme="light"] .dash-menu-item:hover{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .dash-list-item{border-bottom-color:#E8E2DA!important}
html[data-theme="light"] .dash-list-thumb{background:#F0EBE4!important}
html[data-theme="light"] .dash-icon-btn{background:rgba(191,161,100,0.08)!important;border-color:#E8E2DA!important}
html[data-theme="light"] .dash-notif-item{border-bottom-color:#E8E2DA!important}
html[data-theme="light"] .dash-notif-item.unread{background:rgba(191,161,100,.06)!important}
.dash-container{padding-top:80px;padding-bottom:80px;max-width:1100px}

.dash-icon-btn{position:relative;cursor:pointer;color:var(--fm-s,#6B6356);transition:color .2s;width:36px;height:36px;display:flex;align-items:center;justify-content:center;border-radius:50%;background:rgba(191,161,100,0.06);border:1px solid var(--fm-br,#1E1E1E)}
.dash-icon-btn:hover{color:#BFA164;border-color:#BFA164;background:rgba(191,161,100,0.1)}
.dash-notif-badge{position:absolute;top:-4px;right:-4px;background:#FF6B6B!important;color:#fff!important;font-size:9px;font-weight:700;border-radius:10px;padding:1px 5px;min-width:16px;text-align:center}
/* Passive activity indicator — shows when there's been activity in the last 24h but
 * nothing is currently unread. Subtler than the red badge so it doesn't feel like an alert. */
.dash-notif-pulse{position:absolute;top:1px;right:1px;width:8px;height:8px;border-radius:50%;background:#BFA164;box-shadow:0 0 0 2px var(--fm-bg1,#141414);animation:dashBellPulse 2.2s ease-in-out infinite}
.dash-bell-active{color:#BFA164!important;animation:dashBellShake 4s ease-in-out infinite}
@keyframes dashBellPulse{
  0%, 100% { box-shadow:0 0 0 2px var(--fm-bg1,#141414), 0 0 0 0 rgba(191,161,100,.6); }
  50% { box-shadow:0 0 0 2px var(--fm-bg1,#141414), 0 0 0 5px rgba(191,161,100,0); }
}
@keyframes dashBellShake{
  0%, 88%, 100% { transform: rotate(0); }
  90% { transform: rotate(8deg); }
  92% { transform: rotate(-8deg); }
  94% { transform: rotate(6deg); }
  96% { transform: rotate(-4deg); }
  98% { transform: rotate(2deg); }
}
.dash-user-btn{cursor:pointer}
.dash-avatar-sm{width:32px;height:32px;border-radius:50%;background:var(--fm-bg3,#1E1E1E)!important;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;color:#BFA164!important}
.dash-avatar-md{width:40px;height:40px;border-radius:50%;background:var(--fm-bg3,#1E1E1E)!important;display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:700;color:#BFA164!important}
.dash-avatar-xs{width:30px;height:30px;border-radius:50%;background:var(--fm-bg3,#1E1E1E)!important;display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:700;color:#BFA164!important;flex-shrink:0}

/* User Menu */
.dash-user-menu{position:fixed;top:0;left:0;right:0;bottom:0;z-index:150;background:rgba(0,0,0,.3)!important}
.dash-menu-card{position:absolute;top:58px;right:20px;background:var(--fm-bg1,#141414)!important;border:1px solid var(--fm-br,#1E1E1E);border-radius:12px;padding:16px;width:240px;box-shadow:0 8px 24px rgba(0,0,0,.5)}
.dash-menu-item{display:flex;align-items:center;padding:8px;border-radius:6px;color:var(--fm-m,#A09888)!important;font-size:13px;text-decoration:none;transition:all .15s}
.dash-menu-item:hover{background:var(--fm-bg3,#1E1E1E)!important;color:var(--fm-h,#F5F0E8)!important}

/* Welcome */
.dash-welcome{display:flex;align-items:center;justify-content:space-between}

/* Stats */
.dash-stat-card{background:var(--fm-bg1,#141414)!important;border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:16px;text-align:center;transition:all .2s}
.dash-stat-card:hover{border-color:var(--fm-br,#2A2520)}
.dash-stat-val{font-size:22px;font-weight:700;color:var(--fm-h,#F5F0E8)!important;margin-top:6px}
.dash-stat-lbl{font-size:11px;color:var(--fm-s,#6B6356)!important;margin-top:2px}

/* Quick Actions */
.dash-quick-card{background:var(--fm-bg1,#141414)!important;border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:16px;text-align:center;cursor:pointer;transition:all .2s}
.dash-quick-card:hover{border-color:#BFA164;transform:translateY(-2px)}
.dash-quick-label{font-size:12px;color:var(--fm-m,#A09888)!important;margin-top:6px}

/* Cards */
.dash-card{background:var(--fm-bg1,#141414)!important;border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:20px}
.dash-community{display:flex;align-items:center;gap:14px;cursor:pointer;border-radius:14px;padding:16px 18px;background:linear-gradient(120deg,#3a2f17,#1a1207);border:1px solid #BFA164;transition:transform .15s}
.dash-community:hover{transform:translateY(-2px)}
.dash-community-icon{width:50px;height:50px;border-radius:14px;background:rgba(191,161,100,.2);color:#E5C77E;display:flex;align-items:center;justify-content:center;font-size:28px;flex-shrink:0}
.dash-community-body{flex:1;min-width:0}
.dash-community-title{color:#F5F0E8;font-weight:800;font-size:16px;display:flex;align-items:center;gap:8px}
.dash-community-live{background:#E5533C;color:#fff;font-size:9px;font-weight:800;letter-spacing:.5px;padding:1px 6px;border-radius:5px}
.dash-community-sub{color:#D8CDB6;font-size:12.5px;margin-top:2px}
.dash-community-btn{background:#BFA164;border:none;color:#0A0A0A;font-weight:700;font-size:13px;padding:9px 14px;border-radius:9px;white-space:nowrap;flex-shrink:0;display:flex;align-items:center;gap:5px}
@media (max-width:600px){.dash-community-btn{padding:9px 11px}.dash-community-sub{display:none}}

/* Verify-phone banner */
.dash-verify-banner{display:flex;align-items:center;gap:14px;border-radius:12px;padding:14px 16px;background:linear-gradient(120deg,#3a2c10,#1f1808);border:1px solid #F1B44C}
.dash-verify-icon{width:42px;height:42px;border-radius:10px;background:rgba(241,180,76,.18);color:#F1B44C;display:flex;align-items:center;justify-content:center;font-size:22px;flex-shrink:0}
.dash-verify-body{flex:1;min-width:0}
.dash-verify-title{color:#F5F0E8;font-weight:700;font-size:14px}
.dash-verify-sub{color:#D8CDB6;font-size:12.5px;margin-top:2px}
.dash-verify-actions{display:flex;align-items:center;gap:6px;flex-shrink:0}
.dash-verify-dismiss{background:transparent;border:none;color:#A09888;width:30px;height:30px;border-radius:8px;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:18px}
.dash-verify-dismiss:hover{background:rgba(255,255,255,.06);color:#F5F0E8}
@media (max-width:600px){.dash-verify-sub{display:none}}
html[data-theme="light"] .dash-verify-banner{background:linear-gradient(120deg,#FFF5DD,#FFFBF0)!important;border-color:#F1B44C!important}
html[data-theme="light"] .dash-verify-title{color:#1A1A1A!important}
html[data-theme="light"] .dash-verify-sub{color:#6B6356!important}

/* Verify-phone modal */
.dash-verify-modal{position:fixed;inset:0;background:rgba(0,0,0,.7);display:flex;align-items:center;justify-content:center;z-index:2000;padding:20px}
.dash-verify-modal-card{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#2A2520);border-radius:14px;padding:24px;width:100%;max-width:380px}
.dash-verify-modal-head{display:flex;align-items:center;justify-content:space-between;margin-bottom:14px}

/* Credit Passport hero tile — Alex 2026-07-23 */
.dash-credit-card{display:flex;gap:20px;border-radius:14px;padding:18px 20px;background:var(--fm-bg1,#141414)!important;border:2px solid #BFA164;flex-wrap:wrap;align-items:center;cursor:pointer;transition:transform .15s,box-shadow .15s}
html[data-theme="light"] .dash-credit-card{background:#FFFFFF!important}
.dash-credit-card:hover{transform:translateY(-1px);box-shadow:0 6px 20px rgba(191,161,100,.15)}
.dash-credit-left{min-width:170px;text-align:left}
.dash-credit-label{font-size:10px;text-transform:uppercase;letter-spacing:1px;font-weight:600;color:var(--fm-s,#A09888)}
.dash-credit-score{font-size:38px;font-weight:800;color:#BFA164;font-family:'Courier New',monospace;line-height:1;margin-top:2px}
.dash-credit-tier{display:inline-flex;align-items:center;padding:3px 10px;border-radius:20px;color:#fff;font-weight:700;font-size:11px;margin-top:6px}
.dash-credit-right{flex:1;min-width:220px}
.dash-credit-title{color:var(--fm-h,#F5F0E8);font-weight:700;font-size:15px;line-height:1.3}
html[data-theme="light"] .dash-credit-title{color:#1A1A1A}
.dash-credit-sub{color:var(--fm-s,#A09888);font-size:12.5px;margin-top:4px;margin-bottom:8px;line-height:1.4}
.dash-credit-cta{display:inline-flex;align-items:center;gap:6px;color:#BFA164;font-weight:700;font-size:12px}

/* Refer & Earn card — dashboard entry point for the referral QR + recent list */
.dash-refer-card{display:flex;gap:20px;border-radius:14px;padding:18px 20px;background:var(--fm-bg1,#141414)!important;border:2px solid #BFA164;flex-wrap:wrap;align-items:flex-start}
html[data-theme="light"] .dash-refer-card{background:#FFFFFF!important}
.dash-refer-body{flex:1;min-width:240px}
.dash-refer-headline{display:flex;align-items:flex-start;gap:12px;margin-bottom:12px}
.dash-refer-title{color:var(--fm-h,#F5F0E8)!important;font-weight:800;font-size:16px}
html[data-theme="light"] .dash-refer-title{color:#1A1A1A!important}
.dash-refer-sub{color:var(--fm-s,#A09888)!important;font-size:12px;margin-top:2px}
.dash-refer-code{display:inline-flex;align-items:baseline;gap:10px;background:rgba(191,161,100,.08);border:1px solid rgba(191,161,100,.3);border-radius:10px;padding:8px 14px;margin-bottom:12px}
.dash-refer-code-lbl{color:var(--fm-s,#6B6356);font-size:10px;text-transform:uppercase;letter-spacing:1px;font-weight:600}
.dash-refer-code-val{color:#BFA164;font-family:'Courier New',monospace;font-weight:800;font-size:22px;letter-spacing:3px}
.dash-refer-actions{display:flex;flex-wrap:wrap;gap:6px;margin-bottom:12px}
.dash-refer-list{border-top:1px dashed var(--fm-br,#2A2520);padding-top:12px}
.dash-refer-list-lbl{color:var(--fm-s,#6B6356);font-size:11px;text-transform:uppercase;letter-spacing:.6px;font-weight:600;margin-bottom:8px}
.dash-refer-row{display:flex;align-items:center;gap:10px;padding:6px 0;cursor:pointer;border-radius:6px;padding-left:6px;padding-right:6px;margin-left:-6px;margin-right:-6px;transition:background .15s}
.dash-refer-row:hover{background:rgba(191,161,100,.06)}
.dash-refer-avatar{width:30px;height:30px;border-radius:50%;background:#BFA164;color:#fff;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:11px;flex-shrink:0}
.dash-refer-qr{display:flex;flex-direction:column;align-items:center;gap:6px;flex-shrink:0}
.dash-refer-qr-img{width:130px;height:130px;border-radius:10px;background:#FFFFFF;padding:8px;border:1px solid rgba(191,161,100,.35);cursor:zoom-in;transition:transform .15s}
.dash-refer-qr-img:hover{transform:scale(1.02)}
.dash-refer-qr-hint{color:var(--fm-s,#6B6356);font-size:10px;text-align:center;max-width:130px}
.dash-modal-backdrop{position:fixed;inset:0;background:rgba(0,0,0,.6);display:flex;align-items:center;justify-content:center;z-index:9000;padding:16px}
.dash-refer-qr-modal{background:#FFFFFF;color:#1A1A1A;border-radius:14px;padding:24px;width:100%;max-width:440px;position:relative;text-align:center}
.dash-modal-close{position:absolute;top:8px;right:10px;background:transparent;border:none;font-size:22px;color:#6B6356;cursor:pointer}
@media (max-width:640px){
  .dash-refer-card{flex-direction:column-reverse;align-items:stretch}
  .dash-refer-qr{align-self:center}
}

/* Developers banner — first-visit promo for the API portal */
.dash-devs-banner{display:flex;align-items:center;gap:14px;border-radius:14px;padding:16px 18px;background:linear-gradient(120deg,#1a2d3a,#0e1820);border:1px solid #4DB6E5;position:relative;overflow:hidden}
.dash-devs-banner::before{content:"";position:absolute;top:0;right:0;width:160px;height:100%;background:radial-gradient(circle at top right, rgba(77,182,229,.15), transparent 60%);pointer-events:none}
.dash-devs-icon{width:46px;height:46px;border-radius:12px;background:rgba(77,182,229,.18);color:#4DB6E5;display:flex;align-items:center;justify-content:center;font-size:24px;flex-shrink:0;position:relative;z-index:1}
.dash-devs-body{flex:1;min-width:0;cursor:pointer;position:relative;z-index:1}
.dash-devs-title{color:#F5F0E8;font-weight:800;font-size:15px;display:flex;align-items:center;gap:8px}
.dash-devs-tag{background:#4DB6E5;color:#0A0A0A;font-size:9px;font-weight:800;letter-spacing:.5px;padding:1px 6px;border-radius:5px}
.dash-devs-sub{color:#A8C8DC;font-size:12.5px;margin-top:2px}
.dash-devs-cta{background:#4DB6E5;color:#0A0A0A;border:none;font-weight:700;font-size:12.5px;padding:8px 14px;border-radius:9px;flex-shrink:0;display:flex;align-items:center;cursor:pointer;position:relative;z-index:1}
.dash-devs-cta:hover{background:#5FC4F0}
.dash-devs-dismiss{background:transparent;border:none;color:#6B8FA8;width:30px;height:30px;border-radius:8px;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:18px;flex-shrink:0;position:relative;z-index:1}
.dash-devs-dismiss:hover{background:rgba(255,255,255,.06);color:#F5F0E8}
@media (max-width:600px){.dash-devs-sub{display:none}.dash-devs-cta{padding:8px 10px}}
html[data-theme="light"] .dash-devs-banner{background:linear-gradient(120deg,#E8F4FB,#F4FAFD)!important;border-color:#4DB6E5!important}
html[data-theme="light"] .dash-devs-title{color:#1A1A1A!important}
html[data-theme="light"] .dash-devs-sub{color:#4A6378!important}
html[data-theme="light"] .dash-devs-dismiss{color:#6B8FA8!important}
html[data-theme="light"] .dash-devs-dismiss:hover{background:rgba(0,0,0,.04)!important;color:#1A1A1A!important}

/* List Items */
.dash-list-item{display:flex;align-items:center;gap:10px;padding:10px 0;border-bottom:1px solid var(--fm-br,#1A1A1A);cursor:pointer}
.dash-list-item:last-child{border-bottom:none}
.dash-list-item:hover{opacity:.85}
.dash-list-thumb{width:36px;height:36px;border-radius:6px;overflow:hidden;background:var(--fm-bg2,#0F0F0F)!important;display:flex;align-items:center;justify-content:center;flex-shrink:0}
.dash-list-thumb img{width:100%;height:100%;object-fit:cover}

/* Status */
.dash-req-chip{font-size:9px;padding:1px 5px;border-radius:3px}
.dash-status-dot{padding:2px 8px;border-radius:10px;font-size:10px;font-weight:600;text-transform:capitalize}
.st-active{background:rgba(80,200,120,.12)!important;color:#50C878!important}
.st-paused{background:rgba(241,180,76,.12)!important;color:#f1b44c!important}
.st-pending{background:rgba(241,180,76,.12)!important;color:#f1b44c!important}
.st-accepted{background:rgba(80,200,120,.12)!important;color:#50C878!important}
.st-rejected{background:rgba(255,107,107,.12)!important;color:#FF6B6B!important}
.st-countered{background:rgba(108,180,238,.12)!important;color:#6CB4EE!important}
.st-sold{background:rgba(108,180,238,.12)!important;color:#6CB4EE!important}
.st-draft{background:rgba(107,99,86,.2)!important;color:var(--fm-m,#A09888)!important}

/* Notifications */
.dash-notif-item{display:flex;align-items:start;gap:10px;padding:10px 0;border-bottom:1px solid var(--fm-br,#1A1A1A)}
.dash-notif-item:last-child{border-bottom:none}
.dash-notif-item.unread{background:rgba(191,161,100,.03)!important;margin:0 -8px;padding:10px 8px;border-radius:6px}
.dash-notif-dot{width:8px;height:8px;border-radius:50%;background:#BFA164!important;margin-top:4px;flex-shrink:0}

/* ===== MOBILE — feels-like-an-app responsiveness ===== */
@media(max-width:768px){
  .dash-container{padding-top:70px;padding-bottom:calc(82px + env(safe-area-inset-bottom, 0px))}
  .dash-welcome{flex-direction:column;align-items:flex-start;gap:12px}
  .dash-welcome h4{font-size:18px!important}
  .dash-welcome p{font-size:12px!important}
  .dash-stat-card{padding:12px 8px;border-radius:12px}
  .dash-stat-card i{font-size:18px!important}
  .dash-stat-val{font-size:18px;margin-top:4px}
  .dash-stat-lbl{font-size:10px;margin-top:1px;line-height:1.2}
  .dash-quick-card{padding:14px 8px;border-radius:12px}
  .dash-quick-card i{font-size:20px!important}
  .dash-quick-label{font-size:11px;margin-top:4px;line-height:1.2}
  .dash-card{padding:14px;border-radius:12px}
  .dash-community{padding:12px 14px}
  .dash-community-icon{width:42px;height:42px;font-size:22px;border-radius:10px}
  .dash-community-title{font-size:14px}
  .dash-community-btn{font-size:12px;padding:7px 10px}
  .row.g-3{--bs-gutter-x:.6rem;--bs-gutter-y:.6rem}
  .dash-topbar .container{padding-left:12px;padding-right:12px}
  .dash-topbar img{height:28px!important}
  .dash-topbar span.fw-semibold{font-size:14px!important}
}

/* ===== Mobile bottom tab bar (hidden on md+) — native-app feel ===== */
.dash-tabbar{
  position:fixed;left:0;right:0;bottom:0;z-index:140;
  display:flex;justify-content:space-around;align-items:stretch;
  background:rgba(20,20,20,.96);backdrop-filter:blur(14px);
  border-top:1px solid rgba(191,161,100,.15);
  padding:6px 4px calc(6px + env(safe-area-inset-bottom, 0px));
}
html[data-theme="light"] .dash-tabbar{background:rgba(255,255,255,.97);border-top-color:#E8E2DA}
.dash-tab{
  flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;
  gap:2px;padding:6px 4px;color:var(--fm-s,#6B6356);
  text-decoration:none;font-size:10px;font-weight:600;letter-spacing:.2px;
  border-radius:10px;transition:all .15s;min-height:50px;
}
.dash-tab i{font-size:22px;line-height:1}
.dash-tab.active{color:#BFA164}
.dash-tab.active i{transform:scale(1.06)}
.dash-tab:active{background:rgba(191,161,100,.08)}

.dash-overlay{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.7);z-index:2000;display:flex;align-items:center;justify-content:center;padding:16px}
.dash-evidence-modal{background:#1A1A1A;border:1px solid var(--fm-br,#2A2520);border-radius:14px;padding:20px;width:100%;max-width:440px;max-height:90vh;overflow-y:auto}
</style>
<script>
/* eslint-disable */
import { execute, executeJson, flocker, uploads } from "@/api";
import UserAvatar from "@/components/flockr-users/UserAvatar.vue";
import TermsGate from "@/components/flockr-legal/TermsGate.vue";
export default {
  name: "Dashboard",
  components: { UserAvatar, TermsGate },
  data(){return{
    darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',

    loading:true,showUserMenu:false,processing:false,
    cartCount: Number(sessionStorage.getItem('flockr_cart_count') || 0),
    user:{},wallet:{},isVet:false,
    recentListings:[],recentOffers:[],notifications:[],
    unreadCount:0,
    workerFarms:[],workerTasks:[],workerCompleted:[],workerStats:{pendingTasks:0,overdueTasks:0,completedThisWeek:0},
    showWorkerEvidence:false,workerEvidenceTask:{},wEvidencePhotos:[],wEvidenceGps:{lat:null,lng:null,accuracy:null},wEvidenceNotes:'',wCapturingGps:false,wGpsError:'',

    verifyBannerDismissed: localStorage.getItem('flockr_verify_account_dismissed') === '1',
    verifyChannel:{open:false,kind:'phone',otp:'',sending:false,verifying:false,error:''},
    kycBanner: null,   // {status, daysRemaining, listingsAtRisk, ...} — fetched on mount

    developersBannerDismissed: localStorage.getItem('flockr_developers_banner_dismissed') === '1',

    // Refer & Earn card — QR + recent people you've brought in (Alex 2026-07-17)
    referralCode: '',
    referralShareUrl: '',
    referralPeople: [],
    referralWhatsappLink: '',
    referralSmsBody: '',
    referralQrOpen: false,
    referralSmsOpen: false,
    referralSmsPhone: '',
    referralSmsSending: false,
    referralSmsMsg: '',
    referralSmsOk: false,

    // Credit Passport summary — Alex 2026-07-23
    creditPassport: null
  }},
  computed:{
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'},
    themeCardStyle(){return this.darkMode?'background:#141414!important;border:1px solid #1E1E1E!important;':'background:#FFFFFF!important;border:1px solid #E8E2DA!important;'},
    themeInputStyle(){return this.darkMode?'background:#0F0F0F;border:1px solid #2A2520;color:#F5F0E8;':'background:#FFFFFF;border:1px solid #E0D8D0;color:#1A1A1A;'},

    // Refer & Earn QR — generated via api.qrserver.com (no dep). shareUrl already
    // contains ?ref=CODE and Register.vue auto-fills that.
    referralQrUrl(){
      if (!this.referralShareUrl) return '';
      return 'https://api.qrserver.com/v1/create-qr-code/?size=140x140&margin=8&data=' + encodeURIComponent(this.referralShareUrl);
    },
    referralQrUrlLarge(){
      if (!this.referralShareUrl) return '';
      return 'https://api.qrserver.com/v1/create-qr-code/?size=500x500&margin=12&data=' + encodeURIComponent(this.referralShareUrl);
    },

    userInitials(){var n=this.user.display_name||sessionStorage.getItem('userName')||'';if(!n)return'?';return n.split(' ').map(function(w){return w[0]}).join('').substring(0,2).toUpperCase()},
    kycBannerStyle(){
      // Traffic light: red when past due, amber when <=7 days, gold otherwise.
      if(!this.kycBanner) return '';
      var d=this.kycBanner.daysRemaining;
      if(d<0)  return 'border-left:4px solid #FF6B6B;background:rgba(255,107,107,0.06);';
      if(d<=7) return 'border-left:4px solid #FFAB00;background:rgba(255,171,0,0.06);';
      return 'border-left:4px solid #BFA164;background:rgba(191,161,100,0.05);';
    },
    showDevelopersBanner(){
      if(this.loading) return false;
      return !this.developersBannerDismissed;
    },
    showVerifyAccountBanner(){
      if(this.loading) return false;
      if(this.verifyBannerDismissed) return false;
      if(!this.user||!this.user.id) return false;
      // Once EITHER channel is verified, the account is considered verified enough to hide the banner.
      var phoneVerified = !!this.user.phone_verified_at;
      var emailVerified = !!this.user.email_verified_at;
      if(phoneVerified || emailVerified) return false;
      // Google-only accounts with a temp phone (g_<sub>) and no email can't verify anything yet — hide.
      var canVerifyPhone = this.user.phone && String(this.user.phone).indexOf('g_') !== 0;
      var canVerifyEmail = !!this.user.email;
      return canVerifyPhone || canVerifyEmail;
    },
    isAdmin(){
      // Check the role list stored at login time. Server-side assertAdmin() is the real defence.
      try {
        var roles = JSON.parse(sessionStorage.getItem('userRoles') || '[]');
        if (roles.indexOf('admin') > -1 || roles.indexOf('super_admin') > -1) return true;
      } catch(e) {}
      return this.user.role_type==='admin'||sessionStorage.getItem('userRole')==='admin';
    },
    greeting(){var h=new Date().getHours();if(h<12)return'Good morning';if(h<17)return'Good afternoon';return'Good evening'},
    recentActivityCount(){
      // Count notifications in the last 24h regardless of read state — gives a passive
      // "something happened recently" signal when unreadCount itself is zero.
      if(!this.notifications||!this.notifications.length) return 0;
      var cutoff = Date.now() - 24*60*60*1000;
      return this.notifications.filter(function(n){
        if(!n.created_at) return false;
        return new Date(n.created_at).getTime() >= cutoff;
      }).length;
    },
    hasRecentActivity(){return this.recentActivityCount > 0},
    bellTooltip(){
      if(this.unreadCount > 0) return this.unreadCount + ' unread notification' + (this.unreadCount>1?'s':'');
      if(this.hasRecentActivity) return this.recentActivityCount + ' recent activity in the last 24h';
      return 'Notifications';
    },
    firstName(){
      var n=this.user.first_name||'';
      if(!n){var dn=this.user.display_name||sessionStorage.getItem('userName')||'';n=dn.split(' ')[0]||''}
      return n||'there';
    },
    statsCards(){
      var active=this.recentListings.filter(function(l){return l.status==='active'}).length;
      var pending=this.recentOffers.filter(function(o){return o.status==='pending'}).length;
      return[
        {label:'Active Listings',value:active,icon:'mdi mdi-tag-multiple',color:'#50C878',route:'/my-listings'},
        {label:'Pending Offers',value:pending,icon:'mdi mdi-handshake',color:'#f1b44c',route:'/my-offers'},
        {label:'Wallet',value:'KES '+this.formatPrice(this.wallet.available_balance||0),icon:'mdi mdi-wallet',color:'#BFA164',route:'/wallet'},
        {label:'Notifications',value:this.unreadCount,icon:'mdi mdi-bell',color:'#6CB4EE',route:'/notifications'}
      ]
    },
    quickActions(){return[
      {label:'My Orders',icon:'mdi mdi-receipt',route:'/orders'},
      {label:'My Sales',icon:'mdi mdi-tag-multiple',route:'/orders?role=seller'},
      {label:'My Farm',icon:'mdi mdi-barn',route:'/farm'},
      {label:'Escrow',icon:'mdi mdi-shield-lock',route:'/escrow'},
      {label:'Wallet',icon:'mdi mdi-wallet',route:'/wallet'},
      {label:'My Referrals',icon:'mdi mdi-account-multiple-plus',route:'/my-referrals'},
      {label:'Messages',icon:'mdi mdi-message-text',route:'/messages'},
      {label:'New Listing',icon:'mdi mdi-plus-circle',route:'/sell/create'},
      {label:'Browse Market',icon:'mdi mdi-storefront',route:'/marketplace'},
      {label:'Buy Requests',icon:'mdi mdi-bullhorn',route:'/marketplace/buy-requests'},
      {label:'Find a Vet',icon:'mdi mdi-stethoscope',route:'/vets'},
      {label:'Saved',icon:'mdi mdi-heart',route:'/marketplace/saved'},
      {label:'Send Bill',icon:'mdi mdi-file-document-edit',route:'/sell/bills/new'},
      {label:'Bills Received',icon:'mdi mdi-file-document',route:'/bills'},
      {label:'Credit Passport',icon:'mdi mdi-shield-star',route:'/credit-passport'},
      {label:'Get Verified',icon:'mdi mdi-shield-check',route:'/verification'},
      {label:'Terms & Privacy',icon:'mdi mdi-file-document-outline',route:'/terms'}
    ]},
    canSubmitWorkerEvidence(){
      var t=this.workerEvidenceTask;
      if(t.require_photo==='1'&&this.wEvidencePhotos.length===0)return false;
      if(t.require_gps==='1'&&!this.wEvidenceGps.lat)return false;
      if(t.require_notes==='1'&&!this.wEvidenceNotes.trim())return false;
      return true;
    }
  },
  mounted(){
    // Apply global theme
    var t=localStorage.getItem('flockr_theme')||'dark';window.__flockrSetTheme(t);

    var u=sessionStorage.getItem('userId');
    if(!u){this.$router.push('/login');return}
    this.loadDashboard();
    this.startPresenceHeartbeat();
    this.loadCartCount();
    this.loadReferralSummary();
    this.loadCreditPassport();
    var self=this;
    this._onCartUpdated=function(e){if(e&&e.detail)self.cartCount=Number(e.detail.count||0);};
    window.addEventListener('flockr-cart-updated', this._onCartUpdated);
    // Refresh notification badge when something marks notifications read elsewhere
    this._onNotifChanged=function(){var u=sessionStorage.getItem('userId');if(u)self.fetchNotifications(u);};
    window.addEventListener('flockr-notifications-changed', this._onNotifChanged);
    // Also refresh when the user returns to the tab/page (after marking on /notifications)
    this._onFocus=function(){var u=sessionStorage.getItem('userId');if(u)self.fetchNotifications(u);};
    window.addEventListener('focus', this._onFocus);
    // Refresh user data (name + avatar) when MyProfile saves
    this._onProfileUpdated=function(e){
      if (e && e.detail) {
        if (e.detail.avatar_url !== undefined) self.user.avatar_url = e.detail.avatar_url;
        if (e.detail.display_name) self.user.display_name = e.detail.display_name;
      }
    };
    window.addEventListener('flockr-profile-updated', this._onProfileUpdated);
  },
  beforeUnmount(){
    this.stopPresenceHeartbeat();
    if(this._onCartUpdated) window.removeEventListener('flockr-cart-updated', this._onCartUpdated);
    if(this._onNotifChanged) window.removeEventListener('flockr-notifications-changed', this._onNotifChanged);
    if(this._onFocus) window.removeEventListener('focus', this._onFocus);
    if(this._onProfileUpdated) window.removeEventListener('flockr-profile-updated', this._onProfileUpdated);
  },
  methods:{
    photoUrl(p){if(!p)return'';if(p.startsWith&&p.startsWith('http'))return p;return uploads+String(p).replace('uploads/','')},

    async loadCartCount(){
      var userId=sessionStorage.getItem('userId');if(!userId)return;
      try{
        var f=new FormData();f.append('function','getCartCount');f.append('userId',userId);
        var r=await execute(f,flocker);
        if(r.data&&r.data.success&&r.data.data){
          this.cartCount=Number(r.data.data.cartCount||0);
          sessionStorage.setItem('flockr_cart_count',this.cartCount);
        }
      }catch(e){}
    },

    // Refer & Earn — dashboard card. Same endpoint as /my-referrals.
    async loadReferralSummary(){
      var userId = sessionStorage.getItem('userId');
      if (!userId) return;
      try {
        var f = new FormData(); f.append('function', 'getMyReferrals'); f.append('userId', userId);
        var r = await execute(f, flocker);
        if (r.data && r.data.success && r.data.data) {
          this.referralCode         = r.data.data.referralCode  || '';
          this.referralShareUrl     = r.data.data.shareUrl      || '';
          this.referralPeople       = r.data.data.referrals     || [];
          this.referralWhatsappLink = r.data.data.whatsappLink  || '';
          this.referralSmsBody      = r.data.data.smsBody       || '';
        }
      } catch(e) { console.error('loadReferralSummary', e); }
    },
    async loadCreditPassport(){
      var userId = sessionStorage.getItem('userId');
      if (!userId) return;
      try {
        var f = new FormData(); f.append('function', 'getMyCreditPassport'); f.append('userId', userId);
        var r = await execute(f, flocker);
        if (r.data && r.data.success && r.data.data) {
          this.creditPassport = r.data.data;
        }
      } catch(e) { console.error('loadCreditPassport', e); }
    },
    copyText(text){
      if (!text) return;
      try { navigator.clipboard.writeText(text); }
      catch(e){
        var ta = document.createElement('textarea'); ta.value = text; document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); } catch(_){}
        document.body.removeChild(ta);
      }
    },
    downloadReferralQR(){
      if (!this.referralShareUrl) return;
      window.open(this.referralQrUrlLarge, '_blank');
    },
    // Send referral link via SMS. On mobile we prefer the device's SMS app so
    // it's free for the sender; on desktop we fall back to server-send via the
    // platform SMS provider (Craft SMS on prod).
    async sendReferralSms(){
      var raw = String(this.referralSmsPhone || '').replace(/\D/g, '');
      if (raw.length === 9)                                { raw = '254' + raw; }
      else if (raw.length === 10 && raw.charAt(0) === '0') { raw = '254' + raw.substr(1); }
      if (raw.length !== 12 || raw.substr(0,3) !== '254') {
        this.referralSmsMsg = 'Enter a valid Kenyan phone number (e.g. 0712345678).';
        this.referralSmsOk = false;
        return;
      }
      var isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
      if (isMobile) {
        // Prefill both recipient and body — sender just taps Send in their SMS app.
        var localPhone = '0' + raw.substr(3);
        window.location.href = 'sms:' + localPhone + '?body=' + encodeURIComponent(this.referralSmsBody);
        this.referralSmsMsg = 'Opening your SMS app…';
        this.referralSmsOk = true;
        return;
      }
      // Desktop: server-send via platform SMS provider
      this.referralSmsSending = true;
      this.referralSmsMsg = '';
      try {
        var f = new FormData();
        f.append('function', 'sendReferralSms');
        f.append('userId', sessionStorage.getItem('userId') || '');
        f.append('recipientPhone', raw);
        var r = await execute(f, flocker);
        if (r.data && r.data.success) {
          this.referralSmsMsg = 'SMS sent to +' + raw + '. They\'ll receive it shortly.';
          this.referralSmsOk = true;
          this.referralSmsPhone = '';
        } else {
          this.referralSmsMsg = (r.data && r.data.message) || 'Could not send SMS. Please try WhatsApp instead.';
          this.referralSmsOk = false;
        }
      } catch(e) {
        this.referralSmsMsg = 'Network error. Please try WhatsApp instead.';
        this.referralSmsOk = false;
      }
      this.referralSmsSending = false;
    },
    referralInitials(name){
      if (!name) return '?';
      var parts = String(name).trim().split(/\s+/);
      return (parts[0][0] + (parts[1]?parts[1][0]:'')).toUpperCase();
    },
    formatDateShort(d){
      if (!d) return '';
      var dt = new Date(d);
      return dt.toLocaleDateString('en-KE', { day:'numeric', month:'short' });
    },
    async loadDashboard(){
      this.loading=true;
      var userId=sessionStorage.getItem('userId');
      await Promise.all([
        this.fetchProfile(userId),
        this.fetchListings(userId),
        this.fetchOffers(userId),
        this.fetchWallet(userId),
        this.fetchNotifications(userId),
        this.fetchWorkerDashboard(userId),
        this.checkVetStatus(userId),
        this.fetchKycStatus(userId)
      ]);
      this.loading=false
    },
    startPresenceHeartbeat(){
      var self=this;
      this._sendPresence();
      this._presenceTimer=setInterval(function(){self._sendPresence()},120000);
      window.addEventListener('beforeunload',this._onUnload=function(){
        var userId=sessionStorage.getItem('userId');if(!userId)return;
        var f=new FormData();f.append('function','setOffline');f.append('userId',userId);
        navigator.sendBeacon?navigator.sendBeacon(flocker,f):null;
      });
      document.addEventListener('visibilitychange',this._onVisChange=function(){
        if(document.hidden){self._onUnload();}else{self._sendPresence();}
      });
    },
    stopPresenceHeartbeat(){
      if(this._presenceTimer)clearInterval(this._presenceTimer);
      if(this._onUnload)window.removeEventListener('beforeunload',this._onUnload);
      if(this._onVisChange)document.removeEventListener('visibilitychange',this._onVisChange);
    },
    async _sendPresence(){
      var userId=sessionStorage.getItem('userId');if(!userId)return;
      try{var f=new FormData();f.append('function','updatePresence');f.append('userId',userId);await execute(f,flocker);}catch(e){}
    },
    dismissVerifyBanner(){
      this.verifyBannerDismissed=true;
      localStorage.setItem('flockr_verify_account_dismissed','1');
    },
    async fetchKycStatus(userId){
      try{
        var f=new FormData();f.append('function','getMyKycStatus');f.append('userId',userId);
        var r=await execute(f,flocker);
        if(r&&r.data&&r.data.success) this.kycBanner=r.data.data;
      }catch(e){/* soft-fail — banner just won't show */}
    },
    dismissDevelopersBanner(){
      this.developersBannerDismissed=true;
      localStorage.setItem('flockr_developers_banner_dismissed','1');
    },
    openDevelopersPortal(){
      this.$router.push('/developers');
    },
    closeVerifyChannel(){
      this.verifyChannel.open=false;
      this.verifyChannel.otp='';
      this.verifyChannel.error='';
    },
    async openVerifyChannel(kind){
      // kind is 'phone' or 'email'. Trigger an OTP send (the resend endpoint sends to both channels),
      // then open the modal pre-bound to the chosen channel.
      this.verifyChannel.kind=kind;
      this.verifyChannel.otp='';
      this.verifyChannel.error='';
      this.verifyChannel.sending=true;
      try{
        var r=await executeJson({function:'resendRegistrationOTP',userId:this.user.id||sessionStorage.getItem('userId')},flocker);
        if(!(r.data&&r.data.success)){
          this.verifyChannel.error=(r.data&&r.data.message)||'Could not send code. Please try again.';
        }
        this.verifyChannel.open=true;
      }catch(e){
        this.verifyChannel.error='Connection error. Please try again.';
        this.verifyChannel.open=true;
      }
      this.verifyChannel.sending=false;
    },
    async resendVerifyChannel(){
      this.verifyChannel.sending=true; this.verifyChannel.error='';
      try{
        var r=await executeJson({function:'resendRegistrationOTP',userId:this.user.id||sessionStorage.getItem('userId')},flocker);
        if(!(r.data&&r.data.success)){
          this.verifyChannel.error=(r.data&&r.data.message)||'Could not resend code.';
        }
      }catch(e){this.verifyChannel.error='Connection error. Please try again.'}
      this.verifyChannel.sending=false;
    },
    async submitVerifyChannel(){
      if(this.verifyChannel.otp.length<6) return;
      this.verifyChannel.verifying=true; this.verifyChannel.error='';
      try{
        var params = this.verifyChannel.kind === 'email'
          ? {function:'verifyEmailOTP', email:this.user.email, code:this.verifyChannel.otp, purpose:'registration'}
          : {function:'verifyOTP',      phone:this.user.phone, code:this.verifyChannel.otp, purpose:'registration'};
        var r=await executeJson(params, flocker);
        if(r.data&&r.data.success){
          if(this.verifyChannel.kind === 'email') this.user.email_verified_at=new Date().toISOString();
          else                                    this.user.phone_verified_at=new Date().toISOString();
          this.closeVerifyChannel();
        }else{
          this.verifyChannel.error=(r.data&&r.data.message)||'Invalid code. Please try again.';
        }
      }catch(e){this.verifyChannel.error='Connection error. Please try again.'}
      this.verifyChannel.verifying=false;
    },
    async fetchProfile(userId){
      try{var r=await executeJson({function:"getUserProfile",userId:userId,viewerId:sessionStorage.getItem('userId')||''},flocker);if(r.data.success)this.user=r.data.data.user||{}}catch(e){console.error(e)}
    },
    async fetchListings(userId){
      try{var r=await executeJson({function:"getMyListings",sellerId:userId},flocker);if(r.data.success)this.recentListings=r.data.data.listings||[]}catch(e){console.error(e)}
    },
    async fetchOffers(userId){
      try{var r=await executeJson({function:"getListingOffers",sellerId:userId},flocker);if(r.data.success)this.recentOffers=r.data.data.offers||[]}catch(e){console.error(e)}
    },
    async fetchWallet(userId){
      try{var r=await executeJson({function:"getWalletBalance",userId:userId},flocker);if(r.data.success)this.wallet=r.data.data.wallet||{}}catch(e){console.error(e)}
    },
    async fetchNotifications(userId){
      try{var r=await executeJson({function:"getNotifications",userId:userId,limit:5},flocker);if(r.data.success){this.notifications=r.data.data.notifications||[];this.unreadCount=r.data.data.unread||0}}catch(e){console.error(e)}
    },
    async logout(){
      var userId=sessionStorage.getItem('userId');
      try{await executeJson({function:"logoutUser",userId:userId},flocker)}catch(e){console.error(e)}
      sessionStorage.clear();
      localStorage.removeItem('authToken');
      this.$router.push('/login')
    },
    formatPrice(a){var n=Number(a||0);return n.toLocaleString('en-KE',{minimumFractionDigits:n%1?2:0,maximumFractionDigits:2})},
    formatTimeAgo(d){
      if(!d)return'';
      var now=new Date();var then=new Date(d);var diff=Math.floor((now-then)/(1000*60));
      if(diff<1)return'Just now';if(diff<60)return diff+'m ago';
      if(diff<1440)return Math.floor(diff/60)+'h ago';
      return Math.floor(diff/1440)+'d ago'
    },
    getInitials(n){if(!n)return'?';return n.split(' ').map(function(w){return w[0]}).join('').substring(0,2).toUpperCase()},
    fDate(d){if(!d)return'—';return new Date(d).toLocaleDateString('en-KE',{day:'numeric',month:'short',year:'numeric'})},
    formatTime(t){if(!t)return'';var parts=t.split(':');var h=parseInt(parts[0]);var m=parts[1]||'00';var ampm=h>=12?'PM':'AM';h=h%12||12;return h+':'+m+' '+ampm},

    // Worker Dashboard
    async fetchWorkerDashboard(userId){
      try{
        var r=await executeJson({function:'getWorkerDashboard',userId:userId},flocker);
        if(r.data&&r.data.success){
          this.workerFarms=r.data.data.farms||[];
          this.workerTasks=r.data.data.tasks||[];
          this.workerCompleted=r.data.data.completed||[];
          this.workerStats=r.data.data.stats||{pendingTasks:0,overdueTasks:0,completedThisWeek:0};
        }
      }catch(e){}
    },
    async checkVetStatus(userId){
      try{
        var r=await executeJson({function:'getVetProfile',vetUserId:userId},flocker);
        this.isVet=!!(r.data&&r.data.success&&r.data.data&&r.data.data.vet&&r.data.data.vet.user_id);
      }catch(e){this.isVet=false}
    },
    workerTaskNeedsEvidence(t){return t.require_photo==='1'||t.require_gps==='1'||t.require_notes==='1'},
    async workerStartTask(t){
      this.processing=true;
      try{var r=await executeJson({function:'updateFarmTask',taskId:t.id,status:'in_progress',updatedBy:sessionStorage.getItem('userId')},flocker);
        if(r.data&&r.data.success)await this.fetchWorkerDashboard(sessionStorage.getItem('userId'));else alert(r.data.message||'Failed')
      }catch(e){alert('Error')}this.processing=false;
    },
    async workerCompleteTask(t){
      this.processing=true;
      try{var r=await executeJson({function:'updateFarmTask',taskId:t.id,status:'completed',updatedBy:sessionStorage.getItem('userId')},flocker);
        if(r.data&&r.data.success){await this.fetchWorkerDashboard(sessionStorage.getItem('userId'));alert('Task completed!')}else alert(r.data.message||'Failed')
      }catch(e){alert('Error')}this.processing=false;
    },
    workerCompleteWithEvidence(t){
      this.workerEvidenceTask=t;this.wEvidencePhotos=[];this.wEvidenceGps={lat:null,lng:null,accuracy:null};this.wEvidenceNotes='';this.wGpsError='';
      this.showWorkerEvidence=true;
      if(t.require_gps==='1')this.captureWorkerGps();
    },
    handleWorkerEvidenceFiles(e){
      var files=e.target.files;var self=this;
      for(var i=0;i<files.length;i++){
        (function(file){
          var reader=new FileReader();
          reader.onload=function(ev){
            var img=new Image();
            img.onload=function(){
              var canvas=document.createElement('canvas');
              var maxW=1200;var w=img.width;var h=img.height;
              if(w>maxW){h=h*(maxW/w);w=maxW}
              canvas.width=w;canvas.height=h;
              var ctx=canvas.getContext('2d');ctx.drawImage(img,0,0,w,h);
              // First pass at 0.8
              canvas.toBlob(function(blob){
                // If still > 500KB, second pass at 0.6
                if(blob.size>500000){
                  canvas.toBlob(function(blob2){
                    var final=blob2||blob;
                    self.wEvidencePhotos.push({file:final,preview:URL.createObjectURL(final),size:final.size});
                  },'image/jpeg',0.6);
                }else{
                  self.wEvidencePhotos.push({file:blob,preview:URL.createObjectURL(blob),size:blob.size});
                }
              },'image/jpeg',0.8);
            };
            img.src=ev.target.result;
          };
          reader.readAsDataURL(file);
        })(files[i]);
      }
      e.target.value='';
    },
    openWorkerCamera(){
      var input=document.createElement('input');
      input.type='file';input.accept='image/*';input.capture='environment';
      var self=this;
      input.onchange=function(e){self.handleWorkerEvidenceFiles(e)};
      input.click();
    },
    captureWorkerGps(){
      this.wCapturingGps=true;this.wGpsError='';
      var self=this;
      if(!navigator.geolocation){this.wGpsError='GPS not available';this.wCapturingGps=false;return}
      navigator.geolocation.getCurrentPosition(
          function(pos){self.wEvidenceGps={lat:pos.coords.latitude,lng:pos.coords.longitude,accuracy:pos.coords.accuracy};self.wCapturingGps=false},
          function(err){self.wGpsError=err.code===1?'Location permission denied':err.code===2?'Location unavailable':'GPS timeout — try again';self.wCapturingGps=false},
          {enableHighAccuracy:true,timeout:15000,maximumAge:0}
      );
    },
    async submitWorkerEvidence(){
      this.processing=true;
      try{
        var f=new FormData();
        f.append('function','completeTaskWithEvidence');
        f.append('taskId',this.workerEvidenceTask.id);
        f.append('completedBy',sessionStorage.getItem('userId'));
        if(this.wEvidenceNotes)f.append('evidenceNotes',this.wEvidenceNotes);
        if(this.wEvidenceGps.lat){
          f.append('gpsLat',this.wEvidenceGps.lat);
          f.append('gpsLng',this.wEvidenceGps.lng);
          f.append('gpsAccuracy',this.wEvidenceGps.accuracy||'');
        }
        for(var i=0;i<this.wEvidencePhotos.length;i++){
          f.append('evidence_photo_'+i,this.wEvidencePhotos[i].file,'evidence_'+Date.now()+'_'+i+'.jpg');
        }
        f.append('photoCount',this.wEvidencePhotos.length);
        var r=await execute(f,flocker);
        if(r.data&&r.data.success){
          this.showWorkerEvidence=false;
          await this.fetchWorkerDashboard(sessionStorage.getItem('userId'));
          alert('Task completed with evidence!');
        }else alert((r.data&&r.data.message)||'Failed')
      }catch(e){alert('Error submitting evidence')}
      this.processing=false;
    }
  }
};
</script>